import { render, staticRenderFns } from "./MemberPhoneTab.vue?vue&type=template&id=6c15d852&"
import script from "./MemberPhoneTab.vue?vue&type=script&lang=js&"
export * from "./MemberPhoneTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports